export const messagesMarks = [
  {
    value: 5,
    label: "100",
    amount: 100,
  },
  {
    value: 35,
    label: "1000",
    amount: 1000,
  },
  {
    value: 65,
    label: "10k",
    amount: 10000,
  },
  {
    value: 100,
    label: "100k",
    amount: 100000,
  },
];

export const storageMarks = [
  {
    value: 5,
    label: "5GB",
    amount: 5,
  },
  {
    value: 35,
    label: "10GB",
    amount: 10,
  },
  {
    value: 65,
    label: "50GB",
    amount: 50,
  },
  {
    value: 100,
    label: "100GB",
    amount: 100,
  },
];

export const storiesMarks = [
  {
    value: 5,
    label: "4Cr",
    amount: 4,
  },
  {
    value: 35,
    label: "24Cr",
    amount: 24,
  },
  {
    value: 65,
    label: "72Cr",
    amount: 72,
  },
  {
    value: 100,
    label: "100Cr",
    amount: 100,
  },
];

export const eventsMarks = [
  {
    value: 5,
    label: "5",
    amount: 5,
  },
  {
    value: 35,
    label: "35",
    amount: 35,
  },
  {
    value: 65,
    label: "65",
    amount: 65,
  },
  {
    value: 100,
    label: "100",
    amount: 100,
  },
];
